import { connect } from 'react-redux'
import { useEffect } from 'react'
import moment from 'moment'
import {
  Heart, Unfriend, Flag, Close,
  Tick, BrokenHeart,
  Chats, UserPlus, HeartOutline, Users, UserBlock,
  UserClock, Headset
} from 'assets/icons/components'
import { useTranslation } from 'react-i18next'
import i18n from 'config/i18n'
import { useState } from 'react'
import {  Spinner, Modal, Button } from 'react-bootstrap'
import { HistoryServices, MessageServices } from 'services'
import { addConversation, setConversations } from 'actions'
import { Avatar } from 'components/common'
import PerfectScrollbar from 'components/common/PerfectScrollbar/PerfectScrollbar'
import { SearchButton, SearchWrapper, SearchInput,
  ContentContainer,
  RegistrationIcon,
  ReadIcon,
  LastMessageAt,
  FilterContainer,
  FilterItem,
  FilterIcon,
  FilterLabel,
  FilterEmpty,
  FilterCount
} from './style'
import { RecentLineWrapperDiv, ReportModal, RowActionsMenu } from 'components//common/index'
import { setMainContent, setRegisterModal, setUpgradeModal } from 'actions/mainContent'
import { setIsFullScreen } from 'actions/videoCall'
import { setActiveConversation } from 'actions/chat'
import { DoubleTick } from 'assets/icons/components'
import { FriendServices, UserServices } from 'services/index'
import { acceptFriendRequest, setFriends } from 'actions/relationship'
import { setNewEvent } from 'actions/echo'
import { ECHO_FRIEND_CHANGE } from 'constants/realtimeEvent'
import { toast } from 'components/common/Toast'

const RecentConversations = (props) => {
  const {
    openChat, activeConversation, allConversations, user, dispatch,
    friendRequests, allFriends
  } = props
  const [search, setSearch] = useState('')
  const [isSearching, setIsSearching] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [queries, setQueries] = useState({ page: 2, per_page: 20 })
  const [isAbleNext, setIsAbleNext] = useState(true)
  const [nextPageIndex, setNextPageIndex] = useState(null)
  const [activeTab, setActiveTab] = useState('message')
  const [isShowUnfriendModal, setIsShowUnfriendModal] = useState(false)
  const [askUser, setAskUser] = useState('')
  const [loading, setLoading] = useState(null)
  const [isShowBlockModal, setIsShowBlockModal] = useState(false)
  const [favorites, setFavorites] = useState([])
  const [blockUsers, setBlockUsers] = useState([])

  const { t } = useTranslation('live', { i18n })

  useEffect(() => {
    switch(activeTab) {
      case 'message':
        handleLoadNextPage()
        break;
      case 'favorites':
        handleLoadFavorites()
        break;
      case 'block':
        handleBlockUsers()
        break;
      default:
        
        break;
    }
  }, [activeTab])
  
  const handleSearch = async () => {
    setIsSearching(true)
    const { conversation, error } = await HistoryServices.searchConversation(search)

    if (conversation) {
      dispatch(addConversation(conversation))
    }

    setIsSearching(false)
  }

  useEffect(() => {
    if (nextPageIndex) {
      handleLoadNextPage()
    }
  }, [nextPageIndex])

  const handleLoadNextPage = async () => {
    if (isLoading || !isAbleNext || allConversations?.length < 20) return;

    setIsLoading(true)
    let { conversations } = await HistoryServices.getConversations(queries)
    setQueries({...queries, page: queries.page + 1})
    setIsLoading(false)

    if (conversations) {
      if (conversations.length) {
        const filteredConversations = conversations.filter(
          conv => !allConversations.some(existing => existing.token === conv.token)
        )

        dispatch(setConversations([...allConversations, ...filteredConversations]))
      } else {
        setIsAbleNext(false)
      }
    } 
  }

  const nextPage = () => {
    if (nextPageIndex && nextPageIndex + 3000 > Date.now()) return;

    setNextPageIndex(Date.now())
  }

  const handleRegister = () => {
    dispatch(setMainContent('chat'))
    dispatch(setActiveConversation({ type: 'REGISTER' }))
    dispatch(setIsFullScreen(false))
  }

  const handleChangeTab = (tab) => {
    if (tab === activeTab) return;

    setActiveTab(tab)
  }

  const handleCloseUnfriendModal = () => {
    setIsShowUnfriendModal(false)
    setTimeout(() => {
      setAskUser('')
    }, 200)
  }

  const handleOpenChat = async (friend) => {
    const activeConversation = allConversations.find(conversation => {
      return (
        conversation?.participant?.uid === friend?.sender?.uid ||
        friend?.conversation?.token === conversation?.token
      );
    });

    if (activeConversation) {
      openChat(activeConversation)
    } else {
      if (friend?.conversation?.token) {
        const { conversation } = await HistoryServices.getConversation(friend?.conversation?.token)

        if (conversation) {
          openChat(conversation)
          updateFriendsList(friend, conversation)
          dispatch(addConversation(conversation))
        }
      } else {
        const { conversation } = await MessageServices.getConversation(friend?.sender?.uid)

        if (conversation) {
          openChat(conversation)
          updateFriendsList(friend, conversation)
          dispatch(addConversation(conversation))
        }
      }
    }
  }

  const updateFriendsList = (friend, conversation) => {
    let friends = allFriends.map(item => {
      if (item.id === friend.id) {
        item.conversation = {
          token: conversation.token
        }
      }

      return item
    })

    dispatch(setFriends(friends))
  }

  const unfriendAsk = async (e, friend) => {
    e.stopPropagation()
    setAskUser(friend)
    setIsShowUnfriendModal(true)
  }

  const acceptRequest = async (request) => {
    if (user?.account_tier === 0 && user?.gender === 0) {
      dispatch(setRegisterModal(true))
      return
    }

    setLoading(`accept-${request?.id}`)

    let { friend, error } = await FriendServices.acceptFriendRequest(request?.id)
    if (error) {
      if (error?.response?.data?.exception === 'REQUIRED_PREMIUM') {
        dispatch(setUpgradeModal(true))
      }
    } else {
      dispatch(acceptFriendRequest(friend))
      dispatch(setNewEvent({ event: ECHO_FRIEND_CHANGE, relationship: friend }))
    }

    setLoading(null)
  }

  const unfriend = async () => {
    setIsLoading(true)
    let { data, error } = await FriendServices.cancelFriendRequest(askUser?.id)
    setIsLoading(false)
    setIsShowUnfriendModal(false)

    if (error) {
      toast.error(error?.message)
    } else {
      let relationships = allFriends.filter(relationship => relationship.id !== askUser?.id)
      dispatch(setFriends(relationships))
    }
  }

  const markFavorite = async (event, relationshipId) => {
    event.stopPropagation()

    let { friend, error } = await FriendServices.toggleFavorite(relationshipId)
    if (error) {
      toast.error(error?.message)
    } else {
      let relationships = allFriends.map(relationship => relationship.id === friend.id ? friend : relationship)
      dispatch(setFriends(relationships))
    }
  }

  const blockAsk = async (e, user) => {
    e.stopPropagation()
    setAskUser(user)
    setIsShowBlockModal(true)
  }

  const handleCloseBlockModal = () => {
    setIsShowBlockModal(false)
    setTimeout(() => {
      setAskUser('')
    }, 200)
  }

  const declineRequest = async (event, request) => {
    event.stopPropagation()
    if (loading === `decline-${request?.id}`) return;

    setLoading(`decline-${request?.id}`)

    let { data, error } = await FriendServices.cancelFriendRequest(request?.id)
    if (error) {
      toast.error(error?.message)
    }
    
    setLoading(null)
  }

  const handleLoadFavorites = async () => {
    let { friends, error } = await FriendServices.getFavorites()

    if (friends) {
      setFavorites(friends)
    }
  }

  const handleBlockUsers = async () => {
    let { users } = await UserServices.getBlockedUsers()

    if (users) {
      setBlockUsers(users)
    }
  }

  const unblockUser = async (user) => {
    let { success } = await UserServices.unblock({ user_id: user?.id })

    if (success) {
      let filtered = blockUsers.filter(blockUser => blockUser.id !== user?.id)
      setBlockUsers(filtered)
    }
  }

  const unreadCount = allConversations?.reduce(
    (total, conversation) => total + (conversation?.unread || 0), 0
  ) || 0

  const formatTime = (date) => {
    if (!date) return ''
    const m = moment(date)
    if (!m.isValid()) return ''
    const now = moment()
    if (m.isSame(now, 'day')) return m.format('LT')
    if (m.isSame(now.clone().subtract(1, 'day'), 'day')) return t('Yesterday')
    if (m.isAfter(now.clone().subtract(6, 'days'))) return m.format('ddd')
    if (m.isSame(now, 'year')) return m.format('MMM D')
    return m.format('MMM D, YYYY')
  }

  return (
  <>
    <FilterContainer>
      <FilterItem active={activeTab === 'message'} onClick={() => handleChangeTab('message')} title={t('Conversations')}>
        <FilterIcon>
          <Chats />
          { unreadCount > 0 && <FilterCount>{unreadCount > 99 ? '99+' : unreadCount}</FilterCount> }
        </FilterIcon>
        <FilterLabel>{t('Chats')}</FilterLabel>
      </FilterItem>
      <FilterItem active={activeTab === 'request-friends'} onClick={() => handleChangeTab('request-friends')} title={t('Request friends')}>
        <FilterIcon>
          <UserPlus />
          { friendRequests?.length > 0 && <FilterCount>{friendRequests.length > 99 ? '99+' : friendRequests.length}</FilterCount> }
        </FilterIcon>
        <FilterLabel>{t('Requests')}</FilterLabel>
      </FilterItem>
      <FilterItem active={activeTab === 'favorites'} onClick={() => handleChangeTab('favorites')} title={t('Favorites')}>
        <FilterIcon>
          <HeartOutline />
        </FilterIcon>
        <FilterLabel>{t('Favorites')}</FilterLabel>
      </FilterItem>
      <FilterItem active={activeTab === 'friends'} onClick={() => handleChangeTab('friends')} title={t('Friends')}>
        <FilterIcon>
          <Users />
        </FilterIcon>
        <FilterLabel>{t('Friends')}</FilterLabel>
      </FilterItem>
      <FilterItem active={activeTab === 'block'} onClick={() => handleChangeTab('block')} title={t('Block')}>
        <FilterIcon>
          <UserBlock />
        </FilterIcon>
        <FilterLabel>{t('Block')}</FilterLabel>
      </FilterItem>
    </FilterContainer>
    <ContentContainer>
      {
        activeTab === 'request-friends' && (
          <PerfectScrollbar
            options={{ suppressScrollX: true, useBothWheelAxes:false }}
            // onYReachEnd={() => handleLoadNextPage()}
          >
            {
            friendRequests?.length > 0
              ?
                <>
                  {friendRequests.map(request => (
                    <RecentLineWrapperDiv
                      className='messages__user-wrapper messages__user-wrapper--requests'
                      key={request?.id}
                      onClick={() => handleOpenChat(request)}>
                      <div className='user-wrapper__info'>
                        <Avatar user={request?.sender} />
                        <div className='info__conversation'>
                          <div className='conversation__upper'>
                            <div className='upper__username'>
                              <div className='username__name'>
                                {request?.sender?.name}
                              </div>
                            </div>
                            <div className='upper__actions'>
                              <div
                                className={`actions__icon actions__icon--decline ${loading === `decline-${request?.id}` ? 'actions__icon--loading' : ''}`}
                                onClick={(event) => declineRequest(event, request)}>
                                {loading === `decline-${request?.id}` ?
                                  <Spinner animation='border' size='sm' />
                                  : <Close className='icon__icon' />}
                              </div>
                              <div
                                className={`actions__icon actions__icon--accept ${loading === `accept-${request?.id}` ? 'actions__icon--loading' : ''}`}
                                onClick={() => loading === `accept-${request?.id}` ? '' : acceptRequest(request)}>
                                {loading === `accept-${request?.id}` ?
                                  <Spinner animation='border' size='sm' />
                                  : <Tick className='icon__icon' />}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </RecentLineWrapperDiv>
                  ))}
                </>
              : <FilterEmpty>
                  <UserPlus />
                  {t('No friend requests')}
              </FilterEmpty>
            }
          </PerfectScrollbar>
        )
      }
      {
        activeTab === 'message' && (
          <PerfectScrollbar
            onYReachEnd={() => nextPage()}
          >
            {
              user?.role === 'guest'
              ?
                <RecentLineWrapperDiv
                  className={`messages__user-wrapper`}
                  onClick={() => handleRegister()}>
                  <div className='user-wrapper__info'>
                    <RegistrationIcon>
                      <UserClock />
                    </RegistrationIcon>
                    <div className='info__conversation'>
                      <div className='conversation__upper'>
                        <div className='upper__username'>
                          <div className='username__name'>
                            { t('5 minutes for free') }
                          </div>
                        </div>
                        <div className='upper__time'>{t('Today')}</div>
                      </div>
                      <div className='conversation__lower'>
                        <div className='lower__message'>{t('Registration')}</div>
                        <div className='badge__noti lower__noti'>
                          <div className='noti__noti'>1</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </RecentLineWrapperDiv>
              : <></>
            }
            { user.role === 'admin' &&
              <SearchWrapper>
                <SearchInput placeholder="User uid..." onChange={(event) => setSearch(event.target.value)} />
                <SearchButton onClick={() => handleSearch() } disabled={isSearching}>
                  { isSearching ? <Spinner as='span' animation='border' size='sm' /> : t('Search') }
                </SearchButton>
              </SearchWrapper>
            }
            {
              allConversations?.length > 0 && allConversations.map(conversation => {
                let time = formatTime(conversation?.lastMessage?.created_at)

                return (
                  <RecentLineWrapperDiv
                    key={conversation.token}
                    className={`messages__user-wrapper ${conversation.token === activeConversation?.token ? 'messages__user-wrapper--active' : ''}`}
                    onClick={() => openChat(conversation)}>
                    <div className='user-wrapper__info'>
                      <Avatar user={conversation?.participant} />
                      <div className='info__conversation'>
                        <div className='conversation__upper'>
                          <div className='upper__username'>
                            <div className='username__name'>
                              {conversation?.participant?.name} {conversation?.support && (<Headset className="__support-verify" />)}
                            </div>
                            {conversation?.relationship?.is_favorite && <div className='username__favorite'>
                              <Heart className='favorite__icon' />
                            </div>}
                          </div>
                          <LastMessageAt>{time}</LastMessageAt>
                        </div>
                        <div className='conversation__lower'>
                          {
                            conversation?.lastMessage?.type === 'Text' ?
                              <div className='lower__message'>
                              {
                                conversation?.lastMessage?.read
                                ?
                                <ReadIcon>
                                  <DoubleTick />
                                </ReadIcon>
                                : <></>
                              }
                              <span className='message__text'>{ user?.role === 'guest' ? t('You received a message') : conversation?.lastMessage?.content }</span>
                              </div>
                              : conversation?.lastMessage?.type === 'Image' ? <div className='lower__message'><span className='message__text'>{t('Sent an image')}</span></div> : ''
                          }

                          {conversation?.unread > 0 &&
                            <div className='badge__noti lower__noti'>
                              <div className='noti__noti'>{conversation?.unread}</div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </RecentLineWrapperDiv>
                )
              })
            }

            {
              !allConversations?.length && (
                <FilterEmpty>
                  <Chats />
                  {t('No recent conversations')}
                </FilterEmpty>
              )
            }
          </PerfectScrollbar>
        )
      }

      {
        activeTab === 'friends' && (
          <PerfectScrollbar
            // onYReachEnd={() => nextPage()}
          >
            {
              allFriends.length
              ?
                allFriends.map(friend => (
                  <RecentLineWrapperDiv
                    key={friend.id}
                    className={`messages__user-wrapper ${friend?.conversation?.token === activeConversation?.token ? 'messages__user-wrapper--active' : ''}`}
                    onClick={() => handleOpenChat(friend)}>
                    <div className='user-wrapper__info'>
                      <Avatar user={friend?.sender} />
                      <div className='info__conversation'>
                        <div className='conversation__upper'>
                          <div className='upper__username'>
                            <div className='username__name'>
                              {friend?.sender?.name}
                            </div>
                            {friend?.relationship?.is_favorite && <div className='username__favorite'>
                              <Heart className='favorite__icon' />
                            </div>}
                          </div>
                          <RowActionsMenu
                            items={[
                              friend?.is_favorite
                                ? { icon: <BrokenHeart className='item-icon item-icon--block' />, label: t('Unmark Favorite'), onClick: (event) => markFavorite(event, friend?.id) }
                                : { icon: <Heart className='item-icon' />, label: t('Mark Favorite'), onClick: (event) => markFavorite(event, friend?.id) },
                              { icon: <Unfriend className='item-icon item-icon--unfriend' />, label: t('Unfriend'), onClick: (e) => unfriendAsk(e, friend) },
                              { icon: <Flag className='item-icon item-icon--block' />, label: t('Report/Block'), onClick: (e) => blockAsk(e, friend?.sender) },
                            ]}
                          />
                        </div>
                      </div>
                    </div>
                  </RecentLineWrapperDiv>
                ))
              :
                <FilterEmpty>
                  <Users />
                  {t('No friends')}
                </FilterEmpty>
            }
          </PerfectScrollbar>
        )
      }

      {
        activeTab === 'favorites' && (
          <PerfectScrollbar
            options={{ suppressScrollX: true, useBothWheelAxes:false }}
          >
            {
              favorites.length
              ?
                favorites.map(friend => (
                  <RecentLineWrapperDiv
                    key={friend.id}
                    className={`messages__user-wrapper ${friend?.conversation?.token === activeConversation?.token ? 'messages__user-wrapper--active' : ''}`}
                    onClick={() => handleOpenChat(friend)}>
                    <div className='user-wrapper__info'>
                      <Avatar user={friend?.sender} />
                      <div className='info__conversation'>
                        <div className='conversation__upper'>
                          <div className='upper__username'>
                            <div className='username__name'>
                              {friend?.sender?.name}
                            </div>
                            {friend?.relationship?.is_favorite && <div className='username__favorite'>
                              <Heart className='favorite__icon' />
                            </div>}
                          </div>
                          <RowActionsMenu
                            items={[
                              friend?.is_favorite
                                ? { icon: <BrokenHeart className='item-icon item-icon--block' />, label: t('Unmark Favorite'), onClick: (event) => markFavorite(event, friend?.id) }
                                : { icon: <Heart className='item-icon' />, label: t('Mark Favorite'), onClick: (event) => markFavorite(event, friend?.id) },
                              { icon: <Unfriend className='item-icon item-icon--unfriend' />, label: t('Unfriend'), onClick: (e) => unfriendAsk(e, friend) },
                              { icon: <Flag className='item-icon item-icon--block' />, label: t('Report/Block'), onClick: (e) => blockAsk(e, friend?.sender) },
                            ]}
                          />
                        </div>
                      </div>
                    </div>
                  </RecentLineWrapperDiv>
                ))
              :
                <FilterEmpty>
                  <HeartOutline />
                  {t('No favorites')}
                </FilterEmpty>
            }
          </PerfectScrollbar>
        )
      }

      {
        activeTab === 'block' && (
          <PerfectScrollbar
            options={{ suppressScrollX: true, useBothWheelAxes:false }}
          >
          {
            blockUsers?.length
            ?
            blockUsers.map(user => (
            
                  <RecentLineWrapperDiv
                    key={user.id}
                    className='messages__user-wrapper'>
                    <div className='user-wrapper__info'>
                      <Avatar user={user} />
                      <div className='info__conversation'>
                        <div className='conversation__upper'>
                          <div className='upper__username'>
                            <div className='username__name'>
                              {user?.name}
                            </div>
                          </div>
                          <RowActionsMenu
                            items={[
                              { icon: <Flag className='item-icon item-icon--block' />, label: t('Unblock'), onClick: (e) => unblockUser(user) },
                            ]}
                          />
                        </div>
                      </div>
                    </div>
                  </RecentLineWrapperDiv>
                ))
              
            :
              <FilterEmpty>
                <UserBlock />
                {t('No blocked users')}
              </FilterEmpty>
          }
          </PerfectScrollbar>
        )
      }
      
    </ContentContainer>
    <Modal show={isShowUnfriendModal} onHide={handleCloseUnfriendModal} className='ask-modal'>
        <Modal.Header closeButton>
          <Modal.Title>{t('Unfriend')} { askUser?.sender?.name }?</Modal.Title>
        </Modal.Header>
        <Modal.Body >
          <div className='ask-modal__text'>
            { t('Are you sure want to unfriend {{name}}?', { name: askUser?.sender?.name }) }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className='ask-button' variant='secondary' onClick={() => !isLoading && handleCloseUnfriendModal()}>
            {t('Cancel')}
          </Button>
          <Button className='ask-button' variant='primary' onClick={() => !isLoading && unfriend()}>
            <>{isLoading && <Spinner
                as='span' animation='border' size='sm' role='status'
              />} <span>{t('Unfriend')}</span></>
          </Button>
        </Modal.Footer>
      </Modal>
      <ReportModal
        show={isShowBlockModal}
        hide={handleCloseBlockModal}
        user={askUser}
      >
      </ReportModal>
  </>)
}

const mapStateToProps = (state) => ({
  newEvent: state.echoReducer.newEvent,
  activeConversation: state.chatReducer.activeConversation,
  allConversations: state.chatReducer.conversations,
  friendRequests: state.relationshipReducer.friendRequests,
  allFriends: state.relationshipReducer.friends,
})

export default connect(mapStateToProps)(RecentConversations)

